import { regionFormatters, type FormatDefaults } from '../../../shared/format';
import { regionSettingPreset } from '../../../shared/region-settings';
import type { RegionConfig } from '../../../shared/types/region';

// The locale and currency formatting helpers outside React read. The region
// config provider publishes the deployment's own as soon as it has them; until
// then, and on public pages with no session to fetch them, this is the US
// preset ("en-US", "USD"). Components prefer useFormat(), which re-renders
// when the config arrives.
let published: FormatDefaults = {
  locale: regionSettingPreset('US', 'locale'),
  currency: regionSettingPreset('US', 'currency'),
};

export function publishRegionFormat(config: Pick<RegionConfig, 'locale' | 'currency'>): void {
  if (published.locale !== config.locale || published.currency !== config.currency) {
    published = { locale: config.locale, currency: config.currency };
  }
}

export const regionFormat = regionFormatters(() => published);

/** The currency an amount without one of its own is shown in. */
export const regionCurrencyCode = (): string => published.currency;
